import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Notifications from "react-notification-system-redux";
import styled from "styled-components";

import breakpoints from "_constants/breakpoints";

import { constantActions } from "_store/actions";
import { credentialsActions } from "_store/actions";
import { ordersActions } from "_store/actions";
import { requiredActionsActions } from "_store/actions";

import Header from "components/Header/Header";
import InfoSection from "components/InfoSection/InfoSection";
import Footer from "components/Footer/Footer";

import routes from "routes/routes.js";
import { Spinner } from "react-bootstrap";
import { UpsellModal } from "components/Modals/UpsellModal";

const Container = styled.div`
  background: #fafaff;
  overflow: overlay;

  .notifications-tr {
    @media (max-width: ${breakpoints.mobileM}) {
      max-width: 100vw;
    }
  }
`;

const ContentBody = styled.div`
  min-height: 300px;
`;

const ContentMark = styled.div`
  height: 0;
  opacity: 0;
`;

const DownloadProgress = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 4px 8px;
  background: #98a2b3;
  border: 1px solid lightgray;
  border-radius: 0 12px 0 0;
  color: white;
`;

export default function Membership(props) {
  const dispatch = useDispatch();
  const notifications = useSelector(({ notifications }) => notifications);
  const { filesLoading } = useSelector(({ orders }) => orders);

  const [upsellCode, setUpsellCode] = useState(null);

  const contentRef = useRef(null);

  const scrollToContent = () => contentRef.current.scrollIntoView({ behavior: "smooth" });

  const getRoutes = () =>
    routes.map(({ component: Component, ...prop }, key) => {
      return (
        <Route path={prop.path} element={<Component scrollToContent={scrollToContent} {...props} />} key={key} exact />
      );
    });

  useEffect(() => {
    dispatch(constantActions.getProcessingStatuses());
    dispatch(constantActions.getProcessingErrors());
    dispatch(credentialsActions.getCredentials());
    dispatch(ordersActions.getOrders());
    dispatch(requiredActionsActions.getRequiredActions());
  }, [dispatch]);

  return (
    <Container id="main-panel" className="main-panel">
      <Header {...props} />
      <InfoSection
        scrollToContent={scrollToContent}
        handleSelectUpsell={(code) => {
          setUpsellCode(code);
        }}
      />
      <ContentMark ref={contentRef} />
      <ContentBody>
        <Routes>{getRoutes(routes)}</Routes>
      </ContentBody>
      <Footer />
      <Notifications notifications={notifications} />

      {Boolean(filesLoading) && (
        <DownloadProgress>
          <Spinner size="sm" animation="border" role="status" />
          &nbsp;{`${filesLoading} file(s) downloading...`}
        </DownloadProgress>
      )}

      {upsellCode && (
        <UpsellModal
          upsellInfo={{ productCode: upsellCode }}
          onCancel={() => {
            setUpsellCode(null);
          }}
        />
      )}
    </Container>
  );
}
